import api from './client';

export interface DeviceLog {
  _id: string;
  imei: string;
  vehicle_id: string | null;
  company_id: string | null;
  timestamp: string;
  lat: number | null;
  lon: number | null;
  altitude: number | null;
  speed: number | null;
  ignition: number | null;
  movement: number | null;
  odometer: number | null;
  satellites: number | null;
  action: string | null;
  battery_voltage: number | null;
  coolant_temp: number | null;
  engine_oil_temp: number | null;
  rpm: number | null;
  fuel_level: number | null;
  dtc_count: number | null;
  dtc_codes: string | null;
  oem_odometer: number | null;
  received_at: string;
}

export interface DeviceLogsResponse {
  success: boolean;
  data: {
    logs: DeviceLog[];
    total: number;
    page: number;
    pages: number;
    limit: number;
  };
}

export interface DeviceLogsFilters {
  imei?: string;
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
}

export const deviceLogsApi = {
  async getLogs(filters: DeviceLogsFilters = {}): Promise<DeviceLogsResponse['data']> {
    const params = new URLSearchParams();
    if (filters.imei)  params.set('imei',  filters.imei);
    if (filters.from)  params.set('from',  filters.from);
    if (filters.to)    params.set('to',    filters.to);
    if (filters.page)  params.set('page',  String(filters.page));
    if (filters.limit) params.set('limit', String(filters.limit));
    const response = await api.get<DeviceLogsResponse>(`/api/devices/logs?${params.toString()}`);
    return response.data.data;
  },
};
